import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BS2} from "../BS2";
import {BS2GameMode} from "../server/BS2GameMode";
import {BS2Sound} from "../config/sound/BS2Sound";
import {BS2Statics} from "../config/BS2Statics";
import {BS2Symbol} from "../reels/BS2Symbol";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {replaceWithNewSymbolDataType} from "../server/BS2Data";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreesSpinIntro implements SimplePresentation {

    name: string = "FreesSpinIntro";
    _soundLoopTl: gsap.core.Timeline;

    constructor() {

    }

    public shouldRun(): boolean {
        return !BS2.model.isSuperFreespin() && BS2.model.isNextSuperFreespin();
    }

    public start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();

        BS2.autoPlayPlugin.turnOffAutoplayOnBonus();

        tl.add(BS2.transitionScreen.showIntro(() => {
            this._soundLoopTl = gsap.timeline();
            // this._soundLoopTl.add(() => {
            //     BS2.soundPlayer.playSound(BS2Sound.SFS_HEART);
            // }, "+=1.348").repeat(-1).play();
        }));


        tl.add(() => {
            BS2.soundPlayer.playSound(BS2Sound.SFS_INTRO_START);
            BS2.soundPlayer.playSfsIntroLoop();
        }, "<");

        tl.add(BS2.transitionScreen.enableButton(() => this.onButtonClick(controller)));
        tl.add(<any>BS2.keypadPlugin.hide(0.1), 0);

    }

    private onButtonClick(controller: SimplePresentationRunnerController) {
        BS2.reelView.setReeSet(BS2Statics.LEVEL_REEL_SETS[5]);
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            BS2.soundPlayer.playSound(BS2Sound.SFS_START);
            BS2.soundPlayer.stopSfsIntroLoop();
            BS2.soundPlayer.switchMusic(BS2GameMode.FREESPIN_SUPER);
            BS2.keypadPlugin.setZeroBetSpinCounter(BS2.model.data.freespinsLeft);
            BS2.keypadPlugin.show(0.1);
            this._soundLoopTl.pause();
            this._soundLoopTl.kill();
        });
        tl.add(BS2.transitionScreen.hideIntro());
        tl.add(() => controller.finish());
        // tl.add(() => {
        //     BS2.reelView.collectBar.hide(0.3);
        // })
    }
}